export default __webpack_public_path__ + "static/media/clip-blue.f0ac9271.svg";